"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useActivityKeysByRead;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns an arrays of two list of activity keys: read and unread.
 */
function useActivityKeysByRead() {
  return (0, _useContext.default)().activityKeysByReadState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VBY3Rpdml0eUtleXNCeVJlYWQiLCJ1c2VBY3Rpdml0eUFja25vd2xlZGdlbWVudENvbnRleHQiLCJhY3Rpdml0eUtleXNCeVJlYWRTdGF0ZSJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3Byb3ZpZGVycy9BY3Rpdml0eUFja25vd2xlZGdlbWVudC91c2VBY3Rpdml0eUtleXNCeVJlYWQudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VBY3Rpdml0eUFja25vd2xlZGdlbWVudENvbnRleHQgZnJvbSAnLi9wcml2YXRlL3VzZUNvbnRleHQnO1xuXG4vKipcbiAqIFJldHVybnMgYW4gYXJyYXlzIG9mIHR3byBsaXN0IG9mIGFjdGl2aXR5IGtleXM6IHJlYWQgYW5kIHVucmVhZC5cbiAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlQWN0aXZpdHlLZXlzQnlSZWFkKCk6IHJlYWRvbmx5IFtyZWFkb25seSBzdHJpbmdbXSwgcmVhZG9ubHkgc3RyaW5nW11dIHtcbiAgcmV0dXJuIHVzZUFjdGl2aXR5QWNrbm93bGVkZ2VtZW50Q29udGV4dCgpLmFjdGl2aXR5S2V5c0J5UmVhZFN0YXRlO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFQTtBQUNBO0FBQ0E7QUFDZSxTQUFTQSxxQkFBVCxHQUFrRjtFQUMvRixPQUFPLElBQUFDLG1CQUFBLElBQW9DQyx1QkFBM0M7QUFDRCJ9